import NewPasswordRequiredForm from "./NewPasswordRequiredForm";

export default NewPasswordRequiredForm;
